import React, { useEffect, useState } from 'react';
import AppraisalRootLayout from './Layout/AppraisalRootLayout';
import Goal from './golas/Goal';
import Kra from './Kra';
import SkillAndWill from './SkillAndWill';
import GoalLandingView from '../../appraisal/goalManagement/GoalLandingView';
import TeamGoal from './golas/TeamGoals/TeamGoal';
import TeamKra from './TeamKra';
import { getUserUnder } from '../../../redux/features/generalSlice';
import { useDispatch } from 'react-redux';
import { SelfAppraisalLanding } from '../../appraisal/evaluation/SelfAppraisalLanding';
import EvaluationLanding from '../../appraisal/evaluation/EvaluationLanding';
import KraLanding from '../../appraisal/adminOperations/userSpecific/Kra/KraLanding';
import SkillsUserSpecific from './adminOperations/userSpecificOperations/skills/SkillsUserSpecific';
import WillUserSpecific from './adminOperations/userSpecificOperations/will/WillUserSpecific';
import TeamSkillWillKra from './TeamSkillWillKra';

const Index = () => {
  const cred = JSON.parse(localStorage.getItem('cred') || '{}');
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getUserUnder());
  }, []);
  const selectedUser = {
    userID: cred?.profile?.userId,
  };
  const tabData = [
    {
      tabName: 'Goal',
      component: <GoalLandingView />,
      teamComponent: <TeamGoal />,
    },
    {
      tabName: 'Kra',
      component: <KraLanding user={selectedUser} induvidualView={true} />,
      teamComponent: <TeamSkillWillKra type={'kra'} />,
    },
    {
      tabName: 'Skill',
      component: <SkillsUserSpecific user={selectedUser} induvidualView={true} />,
      teamComponent: <TeamSkillWillKra type={'skills'} />,
    },
    {
      tabName: 'Will',
      component: <WillUserSpecific user={selectedUser} induvidualView={true} />,
      teamComponent: <TeamSkillWillKra type={'will'} />,
    },

    // {
    //   tabName: "KPI (Key Performance Indicators)",
    //   component: <SkillAndWill />,
    // },
    { tabName: 'Evaluations', component: <EvaluationLanding /> },
  ];
  const [sectionName, setSectionName] = useState(tabData?.[0] || {});
  const [viewType, setViewType] = useState('');
  const profile = JSON.parse(localStorage.getItem('cred')).profile;
  const rh = profile.isReportingHead;
  useEffect(() => {
    if (rh) {
      setViewType(1);
    } else {
      setViewType('');
    }
  }, [rh]);

  return (
    <AppraisalRootLayout
      data={tabData}
      reportingHead={rh}
      state={{ sectionName, setSectionName, viewType, setViewType }}
    />
  );
};

export default Index;
